import React, { useEffect, Fragment, useState } from "react";
import { Row, Col } from "reactstrap";
import { MODULE_API } from "../../../../apis";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../../../../components/styled-components/loader/loader";
import law from "../../../../assets/images/latest/law.png";
import Distributions from "../../../../assets/images/latest/Distributions.png";
import stock from "../../../../assets/images/stock.png";
import Trust from "../../../../assets/images/latest/Trust.png";
import { SelectionSkeleton } from "../../../../newComponents/Skeletons/SelectionSkeleton";
import "./styles/IncomeSelect.css";

const IncomeAllocation = () => {
  const [loading, setIsLoading] = useState(true);
  const history = useHistory();
  // new states for income
  const [legaldata, setLegalData] = useState([]);
  const [contractdata, setContractData] = useState([]);
  const [paymentdata, setPaymentData] = useState([]);
  const [stockdata, setStockData] = useState([]);

  async function getAllIncomeAssets() {
    setIsLoading(true);
    let data = await MODULE_API.insuraceAllocation("Income");
    if (data && data.data) {
      console.log("data inside insuarce", data.data);
      data.data.map((item) => {
        if (item.name === "Non-Investment Income") {
          item.type.map((item) => {
            if (item.name === "Legal") {
              setLegalData(item.child);
            }
            if (item.name === "Contract") {
              setContractData(item.child);
            }
            if (item.name === "Payment") {
              setPaymentData(item.child);
            }
          });
        }
        if (item.name === "Investment Income") {
          item.type.map((item) => {
            if (item.name === "Stock") {
              setStockData(item.child);
            }
          });
        }
      });
    }
    setIsLoading(false);
  }

  function handleIncomeSelect(name) {
    history.push(`/income_new/attributes/${name}`);
  }
  useEffect(() => {
    getAllIncomeAssets();
  }, []);

  return (
    <Fragment>
      <div className="info-form-block">
        <Row gutter={16}>
          <Col span={24}>
            <h2 className="text-center font-weight-bold mb-4" style={{fontFamily:"Poppins"}}>
              Select the Type of Income
            </h2>
          </Col>
        </Row>
      
      </div>
      <div className="selelctmain">
        <h3 className="selectHeadingmain">Non-Investment Income</h3>
        <div className="submainImage" >
        <img src={Distributions} height="50px" width="50px" />
      </div>
      {loading && <SelectionSkeleton count={3} />}
      <div className="selectmainincome">
        {paymentdata &&
          paymentdata.map((item, index) => (
            <div
              key={index}
              onClick={() => handleIncomeSelect(item.name)}
              className="selectMaincards"
            >
              <div className="selectMaincardsInner">
                {" "}
                <div className="selectMainHeader">
                  <span className="selectheadingValue">{item.name}</span>
                </div>
              </div>
            </div>
          ))}
      </div>
        <div className="submainImage">
          <img src={law} height="50px" width="50px" />
        </div>
        {loading && <SelectionSkeleton count={3} />}
        <div className="selectmainincome">
          {legaldata &&
            legaldata.map((item, index) => (
              <div
                key={index}
                onClick={() => handleIncomeSelect(item.name)}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
        {/*<div className="submainImage">
          <img src={Trust} height="50px" width="50px" />
        </div>
        {loading && <SelectionSkeleton count={3} />}
        <div className="selectmainincome">
          {contractdata &&
            contractdata.map((item, index) => (
              <div
                key={index}
                onClick={() => handleIncomeSelect(item.name)}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name}</span>
                  </div>
                </div>
              </div>
            ))}
        </div> */}
       
        <h3 className="selectHeadingmain" style={{ marginTop: "2rem" }}>
          Investment Income
        </h3>
        <div className="submainImage">
          <img src={stock} height="50px" width="50px" />
        </div>
        {loading && <SelectionSkeleton count={3} />}
        <div className="selectmainincome">
          {stockdata &&
            stockdata.map((item, index) => (
              <div
                key={index}
                onClick={() => handleIncomeSelect(item.name)}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </Fragment>
  );
};

export default IncomeAllocation;
